<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 316.19 349.78"
       :style="style">
    <title>LogoSquare</title>
    <path id="Icon" class="cls-1" d="M38.67,325.45C27.93,316.59,20,306,17.83,291c-1.62-10.94.19-21.7,3.92-31.91,6.65-18.18,14-36.11,21.23-54.63.74,5.69,1.3,10.86,2.1,16a72.85,72.85,0,0,0,13.21,31.39c11.45,16,13.18,32.91,7.18,50.85v12.36H82.36a102.12,102.12,0,0,1,12.86-14.41c9.54-8.74,21.17-11.36,33.54-11.67,17.18-.43,33-5,47.29-14.64a7.78,7.78,0,0,1,2.41-1.59c-11.32,17.12-23.1,35.35-34.54,51.68-7.27,10.36-16.71,18.64-29,22.87-15.13,5.2-29.74,2.2-44.12-3.21-1.64-.61-3.22-1.39-5.13-2.23h-27ZM246.34,47.11h87.09V341.87H179.35v-26.8H306.63V73.91H246.34V47.11Zm-29.62,146c-11.32,17.12-23.1,35.35-34.54,51.68-7.27,10.36-16.71,18.64-29,22.87-15.13,5.2-29.74,2.2-44.12-3.21-1.65-.62-3.23-1.4-5.16-2.24,8.53-15,16.95-29.6,29.6-41.2,9.54-8.73,21.17-11.36,33.54-11.67,17.18-.43,33-5,47.29-14.64a7.78,7.78,0,0,1,2.41-1.59ZM91.07,255.85c-17.64-11.06-31.86-23.45-35-44.42-1.62-10.94.19-21.7,3.92-31.91,6.65-18.18,14-36.11,21.23-54.63.74,5.69,1.3,10.86,2.1,16a72.87,72.87,0,0,0,13.21,31.39c11.78,16.43,13.27,33.9,6.63,52.42-3.67,10.25-7.88,20.31-12.13,31.16Zm165.7-141.2c-11,16.63-21.73,33.44-33.14,49.79-3.84,5.51-9,10.31-14.21,14.62-14.21,11.71-30.56,13.27-47.8,8.66-5.43-1.45-10.7-3.52-16.48-5.46,9.35-16.34,18.19-32.18,32.72-43.82,8-6.42,17.43-8.86,27.38-9.13,18.42-.48,35.72-4.37,51.53-14.66ZM132.56,175.43c-9.81-5.85-17.83-12-24.32-20.06C95,139,94.54,120.45,100.82,101.6c5.32-16,12.1-31.43,18.2-47.13a66.52,66.52,0,0,1,3.91-9.06c.26,2.92.49,5.83.77,8.75,1.44,15,7.67,28.19,15.92,40.56,7.13,10.68,10.69,22.27,8.42,35.15a91.92,91.92,0,0,1-3.63,15c-3.63,10.13-7.76,20.06-11.88,30.58ZM92.26,73.91H65.47V127.5H38.67V47.11H92.26v26.8ZM227.4.22c-.83,23.94.67,47.07-4.83,69.75-4.7,19.36-16.62,32.49-34.85,39.95-6.51,2.66-13.3,4.61-19.91,6.87-13.36-29.9-12.14-54.18,8.83-74.59,12.14-11.81,25.94-21.93,39-32.76,3.56-3,7.27-5.73,11.73-9.22Z" transform="translate(-17.23 -0.22)"/>
  </svg>
</template>

<script>
export default {
  name: 'LogoSquare',
  props: ['size'],
  computed: {
    style() {
      let size = Number(this.size);
      if (isNaN(size) || size <= 0) {
        size = 100;
      }
      return `
        width: ${size}px;
        height: ${size}px;
      `;
    },
  },
};
</script>

<style scoped>
.cls-1 {
  fill: #3CC961;
}
</style>



// WEBPACK FOOTER //
// src/assets/LogoSquare.vue